'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var InputButton = require('./InputButton.js');
var ChatInput_module = require('./ChatInput.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ChatInput = ({
  disabled = false,
  value,
  placeholder,
  onKeyDown,
  onChange,
  onFocus,
  onBlur,
  onInputButtonClick,
  inputRef
}) => {
  const [inputValue, setInputValue] = React.useState(value || '');
  const [inputScrollHeight, setInputScrollHeight] = React.useState(40);
  React.useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  // automatically vertically resizes the textarea input for
  // when multiple lines of text are input.
  // FIXME: it goes back to 1 line when the input value is fully
  // cleared, but doesn't decrease height on line deletion before that.
  React.useEffect(() => {
    if (!inputRef?.current) return;
    if (!inputValue) {
      inputRef.current.style['height'] = '2.5rem';
      setInputScrollHeight(40);
      return;
    }
    const newInputScrollHeight = inputRef?.current?.scrollHeight;
    if (typeof newInputScrollHeight === 'number' && newInputScrollHeight !== inputScrollHeight) {
      inputRef.current.style['height'] = `${newInputScrollHeight}px`;
      setInputScrollHeight(newInputScrollHeight);
    }
  }, [inputValue, inputRef, inputScrollHeight]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ChatInput_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement("label", {
    className: ChatInput_module["default"].label,
    htmlFor: "chatInputBox"
  }, !inputValue ? placeholder : ''), /*#__PURE__*/React__default["default"].createElement("textarea", {
    className: ChatInput_module["default"].input,
    id: "chatInputBox",
    ref: inputRef,
    value: inputValue,
    onTouchEnd: () => {
      // input won't focus on mobile with the keyboard up,
      // but forcing it fixes this.
      inputRef.current?.focus();
    },
    autoComplete: "off",
    onKeyDown: e => {
      if (onKeyDown) onKeyDown(e);
    },
    onChange: e => {
      setInputValue(e.target.value);
      if (onChange) onChange(e);
    },
    onFocus: () => {
      if (onFocus) onFocus();
    },
    onBlur: () => {
      if (onBlur) onBlur();
    },
    minLength: 1,
    maxLength: 300
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: ChatInput_module["default"].buttonContainer
  }, /*#__PURE__*/React__default["default"].createElement(InputButton["default"], {
    disabled: !inputValue || disabled,
    onClick: onInputButtonClick
  })));
};

exports["default"] = ChatInput;
